import React from "react";
import Slider from "react-slick";
import { useNavigate, Link } from "react-router-dom";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { BookstoryMobileCss, BookstroyCss } from "../css/Books.style";

const BookStorytList = ({ bookStory }: { bookStory: any }) => {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const bookList = bookStory || [];

    const settingsWeb = {
        dots: false,
        infinite: true,
        speed: 9000,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: 'linear',
        pauseOnHover: true,
        variableWidth: true,
        centerMode: false, // 좌우 불균형 흰 공간 해결을 위해 비활성화
        slidesPerRow: 1,
        arrows: false,
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 9000,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    };

    const handleBookDetail = (bookId: number) => {
        navigate(`/book/bookdetails/${bookId}`);
    };


    return(
        <>

            { isMobile ?

                <>
                    <div className={"flex flex-col w-full min-w-0 justify-center items-center"}>
                        <div className="flex flex-col gap-1 w-full items-center">
                            <span className="text-[24px] font-bold text-black">새로운 작품의 발견</span>
                            <span className="text-[14px] text-black ">북밋에 등록한 작가들의 작품을 장르별로 즐겨 보세요!</span>
                        </div>


                        <div css={BookstoryMobileCss}>
                            <Slider {...settings}  >
                                {bookList.map((image: any, idx: number) => (
                                    <Link key={idx} to={`/book/bookdetails/${image.bookId}`}
                                         className="cursor-pointer block">
                                        <img
                                            src={`data:image/png;base64,${image.coverImage}` || `${process.env.PUBLIC_URL}/img/book_2.jpg`}
                                            alt={`Image ${idx}`}
                                            className="w-[81px] h-[122px] object-cover rounded-md shadow-book"
                                        />
                                    </Link>
                                ))}
                            </Slider>
                        </div>


                    </div>


                </>

                :


                <>

                    <div css={BookstroyCss}>

                    <div className="title">
                        <p>새로운 작품의 발견 </p>
                        <span>북밋에 등록한 작가들의 작품을 장르별로 즐겨 보세요!</span>
                    </div>

                    <div className={"sildeBook"}>
                        <Slider {...settingsWeb} arrows={true}>
                            {bookList.map((image: any, idx: number) => (
                                <Link key={idx} to={`/book/bookdetails/${image.bookId}`} className={"book cursor-pointer block"}>


                                    {image.coverImage ?


                                        <img className="w-full h-full object-cover rounded-md shadow-book" src={ `data:image/png;base64,${image.coverImage}`  || `${process.env.PUBLIC_URL}/img/book_2.jpg`}
                                             alt={`Image ${idx}`}/>

                                        :

                                        <img className="w-full h-full object-cover rounded-xl"
                                             src={`${process.env.PUBLIC_URL}/img/book_2.jpg`} alt="책 이미지"/>

                                    }


                                </Link>
                            ))}
                        </Slider>
                    </div>
                    </div>
                </>


        }


        </>
    )

}

export default BookStorytList;
